<template>
  <section>
    <!-- <UserProfileSubscribedUserStory v-if="UserActivity && ((this.IsNavigationVisible && this.ActiveTab == this.profileTab.ProductHistory) || !this.IsNavigationVisible)" :UserActivity="UserActivity"></UserProfileSubscribedUserStory> -->
    <UserProfileSubscribedUserProductsHistory v-if="productsHistory && ((this.isNavigationVisible && this.activeTab == this.profileTab.ProductHistory) || !this.isNavigationVisible)" :title="productsHistory.Title" :configurations="productsHistory.Configurations" />
    <UserProfileSubscribedUserWallet v-if="(this.isNavigationVisible && this.activeTab == this.profileTab.Wallet) || !this.isNavigationVisible" :accounting="accounting" :subscription-plan="subscriptionPlan" :refer-url="referUrl" @ShowPaymentHistory="ShowPaymentHistory" />
  </section>
</template>

<script>
import UserProfileSubscribedUserStory from '@/components/UserProfileSubscribedUserStory.vue'
import UserProfileSubscribedUserWallet from '@/components/UserProfileSubscribedUserWallet.vue'
import UserProfileSubscribedUserProductsHistory from '@/components/UserProfileSubscribedUserProductsHistory.vue'
import enums from '@/utilities/enums.js'

export default {
  name: 'UserProfileSubscribed',
  components: {
    UserProfileSubscribedUserStory,
    UserProfileSubscribedUserProductsHistory,
    UserProfileSubscribedUserWallet
  },
  mixins: [enums],
  props: {
    userActivity: Object,
    productsHistory: Object,
    accounting: Object,
    subscriptionPlan: Object,
    referUrl: String,
    isNavigationVisible: Boolean,
    activeTab: String
  },
  methods: {
    ShowPaymentHistory () {
      this.$emit('ShowPaymentHistory')
    }
  }
}
</script>
